export const PADDIQ_INTERNAL_EMAIL_DOMAIN = 'paddiq.app';

export function isPaddiqInternalEmail(email: string | null | undefined) {
  return email?.trim().toLowerCase().endsWith(`@${PADDIQ_INTERNAL_EMAIL_DOMAIN}`) === true;
}

export function hasSupportMasqueradeAccess(user: {
  email: string;
  supportMasqueradeAllowed?: boolean | null;
}) {
  // Email addresses are identifiers, not proof of support authorization.
  return user.supportMasqueradeAllowed === true;
}
